<!-- Accordion -->
<p-accordion [activeIndex]="[0, 1, 2, 3]"
             [multiple]="true"
             styleClass="no_border"
             class="w-full h-full ml-3 mr-3">
  <p-accordionTab [header]="'global.general' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Name -->
      <medsurf-slide-edit-shared-name-form [class]="'w-full'"></medsurf-slide-edit-shared-name-form>
      
      <!-- Type -->
      <medsurf-slide-edit-free-form-type-form [class]="'w-full'"></medsurf-slide-edit-free-form-type-form>
      
      <!-- Link -->
      <medsurf-slide-edit-shared-link-form [class]="'w-full'"></medsurf-slide-edit-shared-link-form>
    </div>
  </p-accordionTab>
  <p-accordionTab [header]="'global.description' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Description -->
      <medsurf-slide-edit-shared-description-form [class]="'w-full'"></medsurf-slide-edit-shared-description-form>
    </div>
  </p-accordionTab>
  <p-accordionTab [header]="'global.layout' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Text Layout -->
      <medsurf-slide-edit-shared-text-layout-form [class]="'w-full'"></medsurf-slide-edit-shared-text-layout-form>
      
      <!-- Shape Layout -->
      <medsurf-slide-edit-free-form-shape-form [class]="'w-full'"></medsurf-slide-edit-free-form-shape-form>
      
      <!-- Line Style Layout -->
      <medsurf-slide-edit-free-form-line-style-form [class]="'w-full'"></medsurf-slide-edit-free-form-line-style-form>
      
      <!-- Background Style Layout -->
      <medsurf-slide-edit-free-form-background-style-form [class]="'w-full'"></medsurf-slide-edit-free-form-background-style-form>
    </div>
  </p-accordionTab>
  <p-accordionTab [header]="'global.relation' | translate"
                  headerStyleClass="uppercase">
    <div class="flex flex-column align-items-center">
      <!-- Images -->
      <medsurf-slide-edit-shared-image-form [class]="'w-full'"></medsurf-slide-edit-shared-image-form>
      
      <!-- POIs -->
      <medsurf-slide-edit-shared-poi-form [class]="'w-full'"></medsurf-slide-edit-shared-poi-form>
      
      <!-- Groups -->
      <medsurf-slide-edit-shared-group-form [class]="'w-full'"></medsurf-slide-edit-shared-group-form>
    </div>
  </p-accordionTab>
</p-accordion>
